import * as bootstrap from "bootstrap"
import accessibility from "./common/accessibility";
import toggleDesktopSite from "./common/toggleDesktopSite";
import collapseShow from "./common/collapseShow";
import backToTop from "./pages/backToTop";
import userAnalytics from "./common/userAnalytics";
import { domReady } from "./common/dom-ready";
import { initHistory, trackHistoryItem } from './common/history.js';

initHistory();

const resource = document.getElementById('ecancer-history-resource');

if (resource) {
    trackHistoryItem({
        id: resource.dataset.id,
        type: resource.dataset.type,
        locale: resource.dataset.locale,
        title: resource.dataset.title,
        uri: resource.dataset.uri
    });
}

domReady(function() {
    toggleDesktopSite();
    collapseShow();
    backToTop();
    accessibility();
    userAnalytics();
});
import elsa_styles from '../scss/elsa-base.scss';